import { render, staticRenderFns } from "./ScrollTop.vue?vue&type=template&id=7f23c10e&scoped=true&"
import script from "./ScrollTop.vue?vue&type=script&lang=js&"
export * from "./ScrollTop.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTop.vue?vue&type=style&index=0&id=7f23c10e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23c10e",
  null
  
)

export default component.exports